module.exports = __webpack_public_path__ + "img/veteran.44586991.png";